// packages/api-client/src/services/filesLibrary.ts
import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { FilesLibraryQuery, FilesLibraryResponse } from '@dopomogai/types';

const list = async (query: FilesLibraryQuery = {}): Promise<FilesLibraryResponse | null> => {
  return getApiClient()
    .get('/files/library', { params: query })
    .then(res => res.data)
    .catch(err => handleApiError(err, 'listing files library'));
};

export const filesLibraryService = {
  list,
};